import i18n, { TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { setLocale } from 'yup';

import globalEn from './en.json';
import globalPl from './pl.json';
import loginEn from '@/src/features/pages/login/i18n/en.json';
import loginPl from '@/src/features/pages/login/i18n/pl.json';
import forgetPasswordEn from '@/src/features/pages/forget/i18n/en.json';
import forgetPasswordPl from '@/src/features/pages/forget/i18n/pl.json';
import resetPasswordEn from '@/src/features/pages/reset/i18n/en.json';
import resetPasswordPl from '@/src/features/pages/reset/i18n/pl.json';
import registerEn from '@/src/features/pages/register/i18n/en.json';
import registerPl from '@/src/features/pages/register/i18n/pl.json';
import errorEn from '@/src/features/pages/error/i18n/en.json';
import errorPl from '@/src/features/pages/error/i18n/pl.json';
import authenticatedEn from '@/src/features/pages/authenticated/i18n/en.json';
import authenticatedPl from '@/src/features/pages/authenticated/i18n/pl.json';

const SUPPORTED_LANGUAGES = ['en', 'pl'];

export const resources = {
  en: {
    global: globalEn,
    login: loginEn,
    forgetPassword: forgetPasswordEn,
    resetPassword: resetPasswordEn,
    register: registerEn,
    error: errorEn,
    authenticated: authenticatedEn,
  },
  pl: {
    global: globalPl,
    login: loginPl,
    forgetPassword: forgetPasswordPl,
    resetPassword: resetPasswordPl,
    register: registerPl,
    error: errorPl,
    authenticated: authenticatedPl,
  },
};

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

declare module 'react-i18next' {
  interface CustomTypeOptions {
    defaultNS: 'global';
    returnNull: false;
  }
}

export function buildYupLocale(_: unknown, t: TFunction): void {
  setLocale({
    mixed: {
      required: t('VALIDATION.REQUIRED', { ns: 'global' }),
    },
    number: {
      min: ({ min }) => t('VALIDATION.MIN_NUMBER', { ns: 'global', count: min }),
      max: ({ max }) => t('VALIDATION.MAX_NUMBER', { ns: 'global', count: max }),
    },
    string: {
      email: t('VALIDATION.EMAIL', { ns: 'global' }),
      min: ({ min }) => t('VALIDATION.MIN_STRING', { ns: 'global', count: min }),
      max: ({ max }) => t('VALIDATION.MAX_STRING', { ns: 'global', count: max }),
    },
  });
}

export function detectLanguage(): string {
  const stored = localStorage.getItem('lang');
  if (stored && SUPPORTED_LANGUAGES.includes(stored as any)) return stored;

  const browserLang = navigator.language?.split('-')[0] ?? 'en';
  return SUPPORTED_LANGUAGES.includes(browserLang as any) ? browserLang : 'en';
}

export const defaultNS = 'global';

i18n
  .use(initReactI18next)
  .init({
    ns: ['global', 'login', 'forgetPassword', 'resetPassword', 'register', 'error', 'authenticated'],
    defaultNS,
    resources,
    lng: detectLanguage(),
    fallbackLng: 'en',
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
  }, buildYupLocale);

export default i18n;
